import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable, map } from 'rxjs';
import { Dao } from '../dao';
import { DataLoader } from '../data-loader';

@Injectable({
  providedIn: 'root',
})
export class DocumentDao extends Dao {
  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  private references: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/ged`),
  );

  private gedProviderReferences: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/ged/providers`),
  );

  private gedProductReferences: DataLoader<any> = new DataLoader<any>(() =>
    this.httpApi.get(`/ref/ged/products`),
  );

  saveDocument(
    entity: any,
    accountId: number,
    allowExceptions = false,
  ): Observable<any> {
    let url = `/accounts/${accountId}/documents`;
    if (allowExceptions) url = url + `?allowExceptions=true`;

    return this.httpApi.postFormData(url, entity, {});
  }

  putDocument(entity: any, accountId: number): Observable<any> {
    entity.ownerIds =
      entity.ownerIds && entity.ownerIds.length
        ? entity.ownerIds
        : entity.ownerIds
          ? [entity.ownerIds]
          : [];
    return this.httpApi.put(
      `/accounts/${accountId}/documents/${entity.id}`,
      entity,
    );
  }

  getDocumentContent(gedDocumentId: number): Observable<ArrayBuffer> {
    return this.command(user =>
      this.httpApi.getWithOptions(
        `/accounts/${user.accountId}/documents/${gedDocumentId}`,
        { responseType: 'arraybuffer' },
      ),
    );
  }

  /* Account */
  searchDocument(accountId, criteria): Observable<any> {
    return this.httpApi
      .post(`/accounts/${accountId}/documents/search`, {
        ...criteria,
        sorts: [
          {
            direction: 'DESC',
            property: 'CREATED_AT',
            nullHandling: 'NATIVE',
          },
        ],
      })
      .pipe(map(res => res['content']));
  }

  /* Reference */
  getReferences(): Observable<any> {
    return this.references.get();
  }

  getGedProvidersReference(): Observable<any> {
    return this.gedProviderReferences.get();
  }

  getGedProductsReference(): Observable<any> {
    return this.gedProductReferences.get();
  }

  /* state */
  onUserChange(event: any): void {}

  reset() {}
}
